import config from '@/config';
import request from '@/request/request.gateway.js';
import qs from 'qs';

export default {
	// 获取学生信息列表
	getStudentList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/student/get-student-list`,
			params
		});
	},
	// 获取家长信息列表
	getParentList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/student/get-parent-list`,
			params
		});
	},
	// 获取老师信息列表
	getStaffList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/staff/get-staff-list`,
			params
		});
	},
	// 批量录入人脸
	getBatchUploadList(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/face/batch-upload-face`,
			data: qs.stringify(data)
		});
	},
	// 获取人脸上传进度
	getFaceUploadTaskList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/face/get-face-upload-task-process`,
			params
		});
	},
	// 获取历史上传记录
	getFaceUploadHistoryList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/face/get-face-upload-history`,
			params
		});
	},
	// 获取人脸上传记录(详情)
	getFaceUploadLogsList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/face/get-face-upload-logs`,
			params
		});
	},
	// 设备类型接口
	getDeviceTypeList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/device_type_items`,
			params
		});
	},
	// 选择设备接口
	getSearchDeviceList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/device_search`,
			params
		});
	},
	// 选择姓名接口
	getSearchRepetitionList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/resource_name_search`,
			params
		});
	},
	// 后台_学校人脸服务管理_获取识别配置configuration
	getRepetitionConfig(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/face_recognition_config_detail`,
			params
		});
	},
	// 后台_学校人脸服务管理_获取识别配置列表
	getRepetitionConfigList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/face_recognition_config_items`,
			params
		});
	},
	// 后台_学校人脸服务管理_搜索识别配置
	getSearchRepetitionConfig(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/face_recognition_config_search`,
			params
		});
	},
	// 后台_学校人脸服务管理_人脸识别开启
	getFaceRepetitionOpen(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/device/v1/face_recognition_config_turn_on`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_学校人脸服务管理_人脸识别关闭
	getFaceRepetitionClose(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/device/v1/face_recognition_config_turn_off`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_学校人脸服务管理_一次人脸识别设置
	getOnceRepetitionList(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/device/v1/face_recognition_config_setup_first`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_学校人脸服务管理_二次人脸识别设置
	getTwiceRepetitionList(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/device/v1/face_recognition_config_setup_second`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_学校人脸服务管理_三次人脸识别设置
	getThriceRepetitionList(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/device/v1/face_recognition_config_setup_third`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 开始同步腾讯云
	getSyncRepetitionList(data) {
		return request({
			method: 'post',
			url: `${
				config.api.admin
			}/device/v1/face_recognition_config_start_tx_sync`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 搜索腾讯云同步失败记录
	getSearchRepetition(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/tx_sync_fail_search`,
			params
		});
	},
	// 获取人脸识别记录
	getSearchRecordList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/face_record_log`,
			params
		});
	},
	// 获取同步状态
	getSynchState(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/tx_sync_status`,
			params
		});
	},
	// 人脸同步列表
	getHotPeriod(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/hot_period_items`,
			params
		});
	},
	getHotPeriodSave(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/device/v1/hot_period_save`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};
